import { LogLevel } from '@azure/msal-browser';

const logLevelMap: Record<LogLevel, (message: string) => void> = {
  [LogLevel.Error]: console.error,
  [LogLevel.Info]: console.info,
  [LogLevel.Verbose]: console.debug,
  [LogLevel.Warning]: console.warn,
  [LogLevel.Trace]: console.trace,
};

export const loggerCallback = (level: LogLevel, message: string, containsPii: boolean) => {
  if (containsPii) {
    return;
  }

  const logFunction = logLevelMap[level];
  if (logFunction) {
    logFunction(message);
  }
};
